import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import "../css/BecomeMemberDialog.css";
import { WEB_LINK } from "utils/strings";
import { PROFILE_STATUS } from "utils/constants";
import ROUTE_PATHS from "utils/routePaths";
import { useNavigate } from "react-router-dom";

interface BecomeMemberDialogProps {
  profileStatus: string;
  open: boolean;
  onClose: () => void;
}

const TEXT_MAP = {
  [PROFILE_STATUS.NON_MEMBER]: {
    header: "Unlock the benefits",
    discription:
      "Access to member benefits is exclusive to members only Join today to unlock full access",
    buttonText: "Become A Member",
  },
  [PROFILE_STATUS.UNDER_REVIEW]: {
    header: "Almost There, Trailblazer",
    discription:
      "Your membership review is underway.The Foundry’s premium packages unlock only once you’re officially part of the tribe.",
    buttonText: "Got it — I’ll wait for approval",
  },
};

const BecomeMemberDialog: React.FC<BecomeMemberDialogProps> = ({
  profileStatus,
  open,
  onClose,
}) => {
  const texts = TEXT_MAP[profileStatus] ?? {};
  const navigate = useNavigate();

  const handleBecomeMemberClick = () => {
    if (profileStatus === PROFILE_STATUS.NON_MEMBER) {
      navigate(ROUTE_PATHS.WSM_WEB_LINK_DETAIL, {
        state: {
          anyData: {
            title: "Become A Member",
            url: WEB_LINK.BECOME_MEMBER,
          },
        },
      });
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "become-member-dialog-container",
      }}
      BackdropProps={{
        className: "become-member-dialog-backdrop",
      }}
    >
      <DialogContent sx={{ padding: 0, margin: 0 }}>
        <div className="become-member-dialog-header">{texts.header}</div>
        <div className="become-member-dialog-divider"></div>
        <div className="become-member-dialog-containt-container">
          <p>{texts.discription}</p>
        </div>
        <div
          className="become-member-dialog-button"
          onClick={handleBecomeMemberClick}
        >
          <div>{texts.buttonText}</div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BecomeMemberDialog;
